module.exports = "pegasus/assets/themelp1/charity/103.png";